var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-fieldtype-container relative",class:_vm.themeClass},[_c('div',{staticClass:"code-mode",domProps:{"textContent":_vm._s(_vm.modeLabel)}}),_vm._v(" "),_c('div',{ref:"codemirror"})])}
var staticRenderFns = []

export { render, staticRenderFns }